module.exports = {
  'entityName': 'request_has_drug',
  id: ['request_id', 'drug_id'],
  'pagination': {
    'rowsPerPage': 10,
    'page': 1,
    'sortBy': 'request_id',
    'descending': true
  },
  'fields': [
    {
      'value': 'drug_id',
      'text': 'Drug',
      'type': 'autocomplete',
      'title': 'name',
      subtitle: drug => drug.packaging !== 'Labels' ? `${drug.name} (${drug.packaging}, ${drug.dose}${drug.measure_unit})` : `${drug.name} (${drug.packaging} - ${drug.labels?.join(',')}) `,
      'table': {
        'text': 'name'
      },
      render: ({drug}) => drug.packaging !== 'Labels' ? `${drug.name} (${drug.packaging}, ${drug.dose}${drug.measure_unit})` : `${drug.name} (${drug.packaging} - ${drug.labels?.join(',')}) `,
      'filter': drug => {
        return { protocol_id: drug.protocol_id, provider_id: drug.provider_id, always_available: 0 }
      },
      'validators': [
        'required'
      ]      
    },
    {
      'value': 'n_pieces',
      'text': 'N. box',
      'type': 'number',
      'table': {
        'sortable': true,
        'filter': false
      },
      'validators': [
        'required',
        'number'
      ]
    }
  ],
  actions: ['remove']
}
